"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _stateMaintainer = _interopRequireDefault(require("./stateMaintainer"));

var _ethereum = _interopRequireDefault(require("./ethereum"));

var _inputPassphrase = _interopRequireDefault(require("./core/inputPassphrase"));

var _getAuthentication = _interopRequireDefault(require("./core/getAuthentication"));

var _getApproval = _interopRequireDefault(require("./core/getApproval"));

var _getWaiting = _interopRequireDefault(require("./core/getWaiting"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Constants
const DEFAULT_STATE = {
  // Wallet
  visible: false,
  // Passphrase  
  passphrase: false,
  // Authentication
  authetication: false,
  qrcode: null,
  // Waiting
  waiting: false,
  // Approval
  approval: false,
  txParams: null
};
const DEFAULT_OPT = {
  networkId: {
    ethereum: 1
  },
  pageRefreshing: true
};

class KambriaWallet extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onProvider", (er, provider) => {
      if (er) return this.done(er, null);
      if (!provider) return this.done(null, null);
      return this.done(null, {
        provider: provider
      });
    });

    _defineProperty(this, "onClose", () => {
      return this.setState(_objectSpread({}, DEFAULT_STATE), () => {
        return this.done(null, null);
      });
    });

    this.options = _objectSpread(_objectSpread({}, DEFAULT_OPT), props.options);
    this.done = props.done;
    this.SM = new _stateMaintainer.default();
    this.state = _objectSpread(_objectSpread({}, DEFAULT_STATE), {}, {
      visible: props.visible
    });
    /**
     * Group of global functions
     */

    window.kambriaWallet = {
      author: 'Tu Phan',
      git: 'https://github.com/kambria-platform/kambria-wallet'
    };
    window.kambriaWallet.networkId = this.options.networkId;

    window.kambriaWallet.getPassphrase = callback => {
      return this.setState({
        passphrase: false,
        returnPassphrase: null
      }, () => {
        return this.setState({
          passphrase: true,
          returnPassphrase: callback
        });
      });
    };

    window.kambriaWallet.getAuthentication = {
      open: (qrcode, callback) => {
        return this.setState({
          authetication: false,
          qrcode: null
        }, () => {
          return this.setState({
            authetication: true,
            qrcode: qrcode,
            returnAuthetication: callback
          });
        });
      },
      close: () => {
        return this.setState({
          authetication: false,
          qrcode: null,
          returnAuthetication: null
        });
      }
    };
    window.kambriaWallet.getWaiting = {
      open: () => {
        return this.setState({
          waiting: true
        });
      },
      close: () => {
        return this.setState({
          waiting: false
        });
      }
    };

    window.kambriaWallet.getApproval = (txParams, callback) => {
      return this.setState({
        approval: false,
        txParams: null,
        returnApproval: null
      }, () => {
        return this.setState({
          approval: true,
          txParams: txParams,
          returnApproval: callback
        });
      });
    };

    window.kambriaWallet.logout = () => {
      this.SM.clearState();
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible) {
      this.setState(_objectSpread({}, DEFAULT_STATE), () => {
        return this.setState({
          visible: this.props.visible
        });
      });
    }
  }

  render() {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_ethereum.default, {
      visible: this.state.visible,
      options: this.options,
      done: this.onProvider
    }), /*#__PURE__*/_react.default.createElement(_inputPassphrase.default, {
      visible: this.state.passphrase,
      done: this.state.returnPassphrase
    }), /*#__PURE__*/_react.default.createElement(_getAuthentication.default, {
      visible: this.state.authetication,
      qrcode: this.state.qrcode,
      done: this.state.returnAuthetication
    }), /*#__PURE__*/_react.default.createElement(_getApproval.default, {
      visible: this.state.approval,
      txParams: this.state.txParams,
      done: this.state.returnApproval
    }), /*#__PURE__*/_react.default.createElement(_getWaiting.default, {
      visible: this.state.waiting
    }));
  }

}

var _default = KambriaWallet;
exports.default = _default;